import React from 'react';

const customConfirmationFronteraDevotionalES = () => (
  <div>
  <h4>¡Gracias por inscribirte!</h4>

  <p>Le damos gracias a Dios por tu vida. Utiliza esta página para recibir tu devocional en el puesto de BGEA. <em>*Hasta agotar existencias.</em></p>
  
  <p><em>“Siempre que oramos por ustedes, damos gracias a Dios, el Padre de nuestro Señor Jesucristo”.</em></p>

  <p>—Colosenses 1:3, NVI</p>
  </div>
);

export default customConfirmationFronteraDevotionalES;